import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-details-payment',
  templateUrl: './details-payment.component.html',
  styleUrls: ['./details-payment.component.scss']
})
export class DetailsPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
